import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import PropTypes from 'prop-types';
import React from 'react';
import MenuSelector from '../MenuSelector';
import ProjectLanguageSelector from '../ProjectLanguageSelector';
import { globalStyles } from '../style/gstheme';

const styles = () => {
    return Object.assign({
        propertiesBox: {
            borderRadius: 4,
            padding: 12,
            display: 'flex',
            flexDirection: 'column',
            border: 'solid 1px #9e9e9e',
            width: 196,
            height: 164
        }
    }, globalStyles);
};

class TSVoptions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lang: this.props.defaultLang,
            property: null
        };
    }

    handleSelectProperty = (property) => this.setState({ property });

    changeLanguage = (lang) => { this.setState({ lang }); }

    render() {

        const { classes, options, onAddColumn, template } = this.props;
        const { property, lang } = this.state;
        const showLang = property && options.some(opt => opt.iri === property && opt.lang);

        const optionsList = options.map((option, index) => ({
            value: option.iri || "Dummy-" + index,
            label: option.label,
            disabled: option.disabled,
            heading: option.heading,
            used: template.tsvColumnProperty && template.tsvColumnProperty.includes(option.iri)
        }));

        return (
            <div className={classes.propertiesBox}>
                <div style={{ flex: '1' }}>
                    <MenuSelector
                        dataTest="type-selector"
                        label="Available Properties"
                        handleChange={this.handleSelectProperty}
                        hintWord="property"
                        options={optionsList} />
                    <div style={{ marginTop: 12, height: 70 }}>
                        {showLang && <ProjectLanguageSelector multiple includeLabel={true} onSelect={this.changeLanguage} />}
                    </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Button
                        disabled={!property}
                        color="primary"
                        data-test="add-column"
                        onClick={() => property && onAddColumn(property, showLang ? lang : null)}
                        startIcon={<AddCircleIcon />}>Add Column</Button>
                </div>
            </div>
        );
    }
}

TSVoptions.propTypes = {
    additionalOptions: PropTypes.func,
    onAddColumn: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired,
    classes: PropTypes.object,
    template: PropTypes.object.isRequired,
    options: PropTypes.array
};

export default withStyles(styles)(TSVoptions);